import { useRef } from 'react';
import classes from './FileUploader.module.scss';
import { RiImageAddFill } from 'react-icons/ri';

const FileUploader = ({nameInput, onSetLogoHandler}) => {
  const fileInputRef = useRef(null);

  const handleClick = (event) => {
    fileInputRef.current?.click();
        const file = event.target.files[0];

        if (file) {
          const reader = new FileReader();

          reader.onloadend = () => {
            const base64String = reader.result;

            onSetLogoHandler(base64String);
          };

          reader.readAsDataURL(file);
        }
  };

  return (
    <label
      htmlFor="file-upload"
      className={classes["label"]}
    >
      <input
        id="file-upload"
        type="file"
        accept="image/*"
        onChange={handleClick}
        ref={fileInputRef}
        className={classes['nativeInput']}
      />
      <div className={classes["iconWrap"]}>
        <RiImageAddFill></RiImageAddFill>
      </div>
    </label>
  );
};

export default FileUploader;
